import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Origin-addr': '127.0.0.1',
        'Application-ID': 'fe-creacionclaveweb-pyme',
        Channel: '132',
        'X-IBM-Client-Id': environment.ibm_client_id,
      },
    });
    return next.handle(request);
  }
}
